import React from 'react';

const FormWrapper: React.FC = ({ children }) => {
  return <div className="p-6 md:py-12 md:px-20 rounded-lg border-2 border-gray-500">{children}</div>;
};

export { FormWrapper };
